import { GenericService } from './generic-service'

class CategoriaService extends GenericService {
  constructor () {
    super('/categorias-obra')
  }
}

export default new CategoriaService()
